import { FC } from "react";

import { Tag, TagType } from "../../../general";

/** The `EnvironmentTag` component properties. */
export interface EnvironmentTagProps {
  /**
   * The current runtime environment identifier (for example the shell's
   * `site.useAnalyticsAPIEnv`). Matching is case-insensitive. Production and
   * unrecognized values render nothing.
   */
  readonly environment?: string;
}

/** Presentational shell tag that labels non-production environments; renders nothing for production or unknown environments. */
export const EnvironmentTag: FC<EnvironmentTagProps> = (props) => {
  const { environment } = props;

  let type: TagType | undefined = undefined;
  let label: string | null = null;

  switch (environment?.toLowerCase()) {
    case "staging":
    case "primestaging":
      type = "success";
      label = "Staging";
      break;
    case "uat":
    case "primeuat":
      type = "error";
      label = "UAT";
      break;
    case "qa":
    case "primeqa":
      type = "warning";
      label = "QA";
      break;
    case "training":
      type = "system-alternative";
      label = "Training";
      break;
    default:
      return null;
  }

  return (
    <Tag type={type} testId="environment-tag">
      {label}
    </Tag>
  );
};
